import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "SecondHeader",
  data() {
      return {
          user: {}, 
          user_slug: {},
          current_wallet_balance:0
      }
  },
  methods: {
    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        currency =  currency.replace("₦", "") //if sign showing as in Edge browser
        currency =  currency.replace("NGN", ""); //strip off NGN
        return currency;
    },
    getUser() {
        let u = localStorage.getItem("cityneeds_user");
        if(u != null) {
            //let user = JSON.parse(u);
            //let fullname = user.user_fullname;
            this.user = u;
            this.user_slug = u.replace(" ", "_");
            this.current_wallet_balance = localStorage.getItem("cityneeds_wb");
        }else{
            this.user = null;
            //not logged in so
            //delete current stored wb
            localStorage.removeItem("cityneeds_wb");
        }
    }
  },
  created: function() {
      this.getUser();
  }
}


// WEBPACK FOOTER //
// ./src/components/Second-Header/script.js